import { render, staticRenderFns } from "./ContributeData.vue?vue&type=template&id=0892cc90&scoped=true"
import script from "./ContributeData.vue?vue&type=script&lang=js"
export * from "./ContributeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892cc90",
  null
  
)

export default component.exports